"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DockerListImageView = void 0;
const Log_1 = __importDefault(require("@common/Log"));
const UI_1 = require("../util/UI");
class DockerListImageView {
    constructor(list) {
        this.list = list;
    }
    imageMatches(checkedId, imageId) {
        if (checkedId === null || imageId === null) {
            return false;
        }
        return checkedId.includes(imageId);
    }
    bind(dataSource, state) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.getDockerImages(dataSource.url, dataSource.options);
                const dockerImages = data.map((d) => {
                    return {
                        id: d.Id.substring(7, 19),
                        tag: JSON.stringify(d.RepoTags),
                        created: new Date(d.Created * 1000),
                    };
                });
                const pendingAdditionsFragment = document.createDocumentFragment();
                const listItems = this.list.querySelectorAll("ons-list-item:not(:first-child)");
                if (typeof state === "undefined" || state === null || typeof state.checkedItemSha !== "string") {
                    state = { checkedItemSha: "INVALIDSHATHATWILLNEVEREXIST" };
                }
                for (const image of dockerImages) {
                    let exists = false;
                    for (const item of listItems) {
                        const id = item.querySelector("label[for] > ons-row > ons-col").innerText;
                        Log_1.default.trace("DockerListImageView::bind(..) - loop candidate; id: " + image.id + "; innerText: " + id);
                        if (image.id.startsWith(id)) {
                            exists = true;
                            if (this.imageMatches(state.checkedItemSha, image.id)) {
                                Log_1.default.trace("DockerListImageView::bind(..) - loop candidate check match; checked: " + state.checkedItemSha + "; id: " + image.id);
                            }
                            break;
                        }
                    }
                    if (!exists) {
                        const item = DockerListImageView.generateListItem(image, this.imageMatches(state.checkedItemSha, image.id));
                        pendingAdditionsFragment.appendChild(item);
                    }
                }
                for (const item of listItems) {
                    let exists = false;
                    for (const image of dockerImages) {
                        const id = item.querySelector("label[for] > ons-row > ons-col").innerText;
                        if (image.id.startsWith(id)) {
                            exists = true;
                            break;
                        }
                    }
                    if (!exists) {
                        this.removeListItem(item);
                    }
                }
                this.addListItems(pendingAdditionsFragment);
            }
            catch (err) {
                Log_1.default.error("DockerListImageView::bind() - ERROR Binding data to list. " + err);
            }
        });
    }
    addListItems(items) {
        this.list.appendChild(items);
    }
    removeListItem(item) {
        this.list.removeChild(item);
    }
    setCheckedItem(item) {
        const radio = item.querySelector("ons-radio");
        radio.checked = true;
    }
    static generateListItem(image, checked) {
        Log_1.default.trace("DockerListImageView::generateListItem( " + image.id + ", " + checked + " )");
        let tagString = image.tag;
        tagString = tagString.replace(",", ",<br/>");
        let dString = image.created.toLocaleString();
        dString = dString.replace(", ", " @ <br/>");
        return document.createRange().createContextualFragment(`
                <ons-list-item tappable>
                    <label class="left">
                        <ons-radio name="docker-image" input-id="radio-${image.id}" ${checked ? "checked" : ""}></ons-radio>
                    </label>
                    <label for="radio-${image.id}" class="center">
                        <ons-row>
                            <ons-col>${image.id}</ons-col>
                            <ons-col style="text-align: center">${tagString}</ons-col>
                            <ons-col style="text-align: center">${dString}</ons-col>
                        </ons-row>
                    </label>
                </ons-list-item>
                `);
    }
    getDockerImages(url, options) {
        return __awaiter(this, void 0, void 0, function* () {
            Log_1.default.info("DockerListImageView::getDockerImages( .. ) - start");
            const start = Date.now();
            const response = yield fetch(url, options);
            if (response.status === 200) {
                Log_1.default.trace("DockerListImageView::getDockerImages(..) - 200 received");
                const json = yield response.json();
                if (Array.isArray(json)) {
                    Log_1.default.trace("DockerListImageView::getDockerImages(..)  - worked; took: " + UI_1.UI.took(start));
                    return json;
                }
                else {
                    Log_1.default.trace("DockerListImageView::getDockerImages(..)  - ERROR Expected array; got " + json);
                    throw new Error("Invalid response body format");
                }
            }
            else {
                Log_1.default.trace("DockerListImageView::getDockerImages(..)  - !200 received: " + response.status);
                throw yield response.text();
            }
        });
    }
}
exports.DockerListImageView = DockerListImageView;
